import ArrayFieldTemplate from './ArrayFieldTemplate';
import ArrayFieldTitleTemplate from './ArrayFieldTitleTemplate';
import ObjectFieldTemplate from './ObjectFieldTemplate';
import TitleFieldTemplate from './TitleFieldTemplate';
import ArrayFieldItemTemplate from './ArrayFieldItemTemplate';
import BaseInputTemplate from './BaseInputTemplate';
import WrapIfAdditionalTemplate from './WrapIfAdditionalTemplate';
import ErrorListTemplate from './ErrorListTemplate';

const templates = {
  ArrayFieldTitleTemplate,
  ArrayFieldTemplate,
  ObjectFieldTemplate,
  TitleFieldTemplate,
  ArrayFieldItemTemplate,
  BaseInputTemplate,
  WrapIfAdditionalTemplate,
  ErrorListTemplate,
};

export default templates;
